/**
 * @fileoverview Component for displaying the header of the staff card.
 * This component includes a back button and the staff member's email.
 */

import BackIcon from '../../../assets/back.svg'

/**
 * @function StaffCardHeader
 * @description Component for displaying the header of the staff card.
 * @param {Novoic.API.Staff} user - The staff member's details.
 * @returns {JSX.Element} - A React component that renders the staff member's details.
 */
export function StaffCardHeader({ user }: { user: Novoic.API.Staff }) {
    return (
        <div>
            <div className="py-7 border-b">
                <div className="flex items-center h-full px-8">
                    <BackIcon
                        onClick={() => history.back()}
                        className="cursor-pointer mr-3 fill-gray-500 hover:fill-gray-900 transition-colors"
                    />
                    <span className="text-2xl font-regular text-gray-600 mr-3">{user.email}</span>
                </div>
            </div>
        </div>
    )
}
